
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AppHeatingSystemHeatingSystemGeneralViewHeatingSystemFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HeatingSystem"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"heatingType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"boilerDevice"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"boilerModel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productSerial"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"manufacturer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"boilerManufacturer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"energyOutputRange"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"waterStorageType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"waterStorageModel"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"waterStorageManufacturer"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"waterStorageCapacity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maintenanceCompany"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numApartmentUnits"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"numCommercialUnits"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"suppliedQuantity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastHydraulicBalancing"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"consumptions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"year"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"energySource"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"amount"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":472}};
    doc.loc.source = {"body":"fragment AppHeatingSystemHeatingSystemGeneralViewHeatingSystemFragment on HeatingSystem {\n  id\n  name\n  heatingType\n  boilerDevice\n  boilerModel\n  productSerial\n  manufacturer\n  boilerManufacturer\n  energyOutputRange\n  waterStorageType\n  waterStorageModel\n  waterStorageManufacturer\n  waterStorageCapacity\n  maintenanceCompany\n  numApartmentUnits\n  numCommercialUnits\n  suppliedQuantity\n  lastHydraulicBalancing\n  consumptions {\n    year\n    energySource\n    amount\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["AppHeatingSystemHeatingSystemGeneralViewHeatingSystemFragment"] = oneQuery(doc, "AppHeatingSystemHeatingSystemGeneralViewHeatingSystemFragment");
        
